import { render, staticRenderFns } from "./NestedMenuItem.vue?vue&type=template&id=173bb218&scoped=true&"
import script from "./NestedMenuItem.vue?vue&type=script&lang=js&"
export * from "./NestedMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173bb218",
  null
  
)

export default component.exports